mainApp.directive('monitorQos', function() {
	return {
		templateUrl: '/public/directives/monitorQos.html',
		scope: {
			type: '=',
			finishedLoading: '=?',
			item: '=?',
			pid: '=?',
		},
		controller: ['$scope', '$timeout', '$state', '$element', 'DateRangeService', 'GeneralUtilsService', function ($scope, $timeout, $state, $element, DateRangeService, GeneralUtilsService) {
			var SEGMENTS_NUM = 50;
			var MIN_STATS_INTERVAL = 5000; // 5 seconds
			// Templates

			var usageAndHealthTemplate =
				'<div ng-repeat="inter in item.interfaces" class="inter-wrapper">' +
					'<div class="inter-info name ellipsis" data-usage="{{(inter.usage / item.usage * 200) || 0}}"><span>{{inter.interfaceName}}</span></div>' +
					'<div class="inter-info usage">{{inter.usage| bytes}} ({{inter.usage / item.usage * 100 | number:0}}%)</div>' +
					'<div class="health-bar-wrapper item-bar-wrapper" ng-if="tableConfig.finishedLayout"> <link-health item="inter" options="tableConfig.healthBarOptions" item-id="item.priority + \'_\' + inter.interfaceId"></link-health></div>' +
				'</div>' +
				'<div class="inter-wrapper total">' +
					'<div class="inter-info name">Total</div>' +
					'<div class="inter-info usage">{{item.usage| bytes}}</div>' +
					'<div class="ruler-wrapper item-bar-wrapper" ng-if="item.usage"><ruler from="tableConfig.fromDate" to="tableConfig.toDate" interval="tableConfig.interval"></ruler></div>' +
				'</div>';


			// getting date range
			$scope.dateRange = DateRangeService.getNewRange();
			DateRangeService.initDateRange($scope.dateRange, true);

			var interval = Math.max(MIN_STATS_INTERVAL, parseInt(($scope.dateRange.to.getTime() - $scope.dateRange.from.getTime()) / SEGMENTS_NUM));
			DateRangeService.zoomTo($scope.dateRange.from.getTime(), $scope.dateRange.to.getTime(), interval); // set bucket duration

			$scope.dateRange.to = new Date(Math.min($scope.dateRange.to.getTime(), new Date().getTime()));

			function parseData(priorities) {
				priorities.forEach(function(priority) {
					priority.name = 'P' + priority.priority;
					priority.usage = 0;
					if (priority.interfaces) {
						priority.interfaces.forEach(function(inter) {
							priority.usage += inter.usage;
							if (inter.buckets) {
								inter.rtStatsList = parseStatsHealth(inter);
							}
						});
					}
				});
				return priorities;
			}

			function parseStatsHealth(inter) {
				var rtStatsList = [];
				if (!inter.buckets || inter.buckets.length === 0) {
					createEmptyBuckets(inter.buckets);
				}
				inter.buckets.forEach(function(bucketStats) {
					var newStat = {
						sampleTime: bucketStats.bucketStartTimestamp,
						sampleTimeEnd: bucketStats.bucketEndTimestamp ? bucketStats.bucketEndTimestamp : bucketStats.bucketStartTimestamp + interval,
						health: [],
					};
					if (bucketStats.healthDetail) {
						// setting the health (color) of the inner segments (shown on hover of segment)
						bucketStats.healthDetail.forEach(function(healthDetail) {
							newStat.health.push(healthDetail);
						});
					}
					rtStatsList.push(newStat);
				});
				return rtStatsList;
			}

			function createEmptyBuckets(buckets) {
				buckets.push({
					bucketStartTimestamp: $scope.dateRange.from.getTime(),
					bucketEndTimestamp: $scope.dateRange.from.getTime() + (interval/2),
					healthDetail: [0],
				});
				buckets.push({
					bucketStartTimestamp: $scope.dateRange.to.getTime() - (interval/2),
					bucketEndTimestamp: $scope.dateRange.to.getTime() - (interval/2),
					healthDetail: [0],
				});
			}

			function init() {
				var qosPriority = $state.params.p ? parseInt($state.params.p) : false;
				$scope.tableConfig = {
					dataURL: function() {
						return '/getSiteQosData?accountId=' + $state.params.accountId + '&pid=' + $scope.pid;
					},
					pageSize: -1,
					fixedLayout: true,
					parseData: function(items) {
						items = parseData(items);
						return items;
					},
					pidForInnerRow: $scope.pid,
					selectedId: qosPriority,
					selectIdentifier: 'priority',
					innerRow:  {path: 'innerRow', template: '<monitor-qos-item pid="tableConfig.pidForInnerRow" item="item" date-range="tableConfig.dateRange" ' +
															'segments-num="tableConfig.segmentsNum" account-id="tableConfig.accountId"></monitor-qos-item>'},
					fields: [
						{ label: 'Priority', path: 'priority', template: '<span>{{item.name}}</span>' },
						{ label: 'Class of Traffic', path: 'priorityTypes', template: '<span>{{item.priorityTypes || "None currently configured"}}</span>' },
						{ label: 'Usage and Health', path:'usage', template: usageAndHealthTemplate, allowOverflow: true},
						{ label: 'Throughput', noSort: true, template: '<span class="glyphicon glyphicon-arrow-up"></span><span class="throughput-up">{{item.throughputUp | bits}}ps</span><br/>'+
						'<span class="glyphicon glyphicon-arrow-down"></span><span class="throughputDown">{{item.throughputDown | bits}}ps</span>' },
						{ label: 'Discarded Pkts.', noSort: true, template: '<span class="glyphicon glyphicon-arrow-up"></span><span class="packetLossUp">{{item.packetDiscardedUp | number:1}}%</span><br/>'+
						'<span class="glyphicon glyphicon-arrow-down"></span><span class="packetLossDown">{{item.packetDiscardedDown | number:1}}%</span>' },
						{ label: 'Delay', noSort: true, template: '{{item.latency | number:0}}ms' },
					],
					type: 'Priorities',
					titleSearch: 'QoS',
					hideCheckboxes: true,
					expandRow: true,
					clientSideSearch: true,
					clientSideSort: true,
					noAutoSelect: !qosPriority,
					afterUpdate: function() {
						var that = this;
						that.finishedLayout = true;
						$timeout(function() {
							// set the usage bars fills
							$($element[0]).find('.inter-info.name').each(function(i, barEl) {
								var $barEl = $(barEl);
								$barEl.css('background', 'linear-gradient(90deg, #158864, white ' + $barEl.data('usage') + '%)');
							});
						}, 0);
					},
					healthBarOptions:{ // options passed on to the health bars via the template
						hideStats: true,
						fixedPopup: true,
						showTicks: false,
						relative: true,
						hideFlags:  true,
						sampleDuration:  1000,
						clickEvent: segmentClick,
						offlineOnlyIfAllOffline: true,
					},
					finishedLayout: false, // flag signifying template we finished after update
					fromDate: $scope.dateRange.from.getTime(),
					toDate: $scope.dateRange.to.getTime(),
					dateRange: $scope.dateRange,
					interval: interval,
					innerLoader: true,
					sortField: 'priority',
					accountId: $state.params.accountId,
					segmentsNum: SEGMENTS_NUM,
				};
			}

			// zoom on segment click
			function segmentClick ($event, item) {
				interval = Math.max(MIN_STATS_INTERVAL, parseInt(($scope.dateRange.to.getTime() - $scope.dateRange.from.getTime()) / SEGMENTS_NUM));
				DateRangeService.zoomTo(item.sampleTime - $scope.dateRange.bucketDuration, item.sampleTimeEnd + $scope.dateRange.bucketDuration, interval);
			}

			init();


			$scope.$on('$destroy', () => {
                GeneralUtilsService.cleanAmChartsFromScope($element);
            });
		}]
	}
});